'use client'
import React from 'react';
import PropertyCard from '@components/PropertyCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import LinkComponent from '@components/LinkComponent';

const PropertyCardSlider = ({ title, description, properties, url, cardType, dictionary, lang }) => {
    return (
        <section className='w-full pl-3 mt-3 pb-3 border-b-[1px] border-b-forth'>
            {url ? (
                <LinkComponent href={`/${url}`}>
                    <h2 className='text-maincolor font-bold text-xl mb-2'>{title[lang]}</h2>
                </LinkComponent>
            ) : (
                <h2 className='text-maincolor font-bold text-xl mb-2'>{title[lang]}</h2>
            )}
            {description?.[lang]?.trim() && (
                <p className='text-secondary'>{description[lang]}</p>
            )}
            <div className='sm:block hidden'>
                <Swiper
                    slidesPerView={'auto'}
                    // spaceBetween={8}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className=''
                >
                    {properties.map((property, index) => (
                        <SwiperSlide key={index} className='w-[250px] property-swiper-slide'>
                            <PropertyCard property={property} dictionary={dictionary.card} cardType={cardType} lang={lang} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {properties && (
                <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.5}
                    >
                        {properties.map((property, index) => (
                            <SwiperSlide key={index}>
                                <PropertyCard property={property} dictionary={dictionary.card} cardType={cardType} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </section>
    );
};

export default PropertyCardSlider;